<template>
  <div class="bh-number-input rounded-pill" lang="en-US">
    <v-btn
      icon
      elevation="0"
      class="decrease bh-number-input__button rounded-0"
      @click="decreaseValue"
      :disabled="readonly"
    >
      <v-icon :color="color">{{ minusIcon }}</v-icon>
    </v-btn>
    <input
      type="number"
      ref="input"
      :id="id"
      :step="step < 1 ? 0.1 : 1"
      lang="en"
      :min="minNumber"
      :max="maxNumber"
      :class="`bh-number-input__input ${showSpinners ? '' : 'hide-spinners'} ${inputClass}`"
      :value="value"
      :disabled="readonly"
      @input="updateValue($event.target.value)"
    />
    <v-btn
      icon
      elevation="0"
      class="increase bh-number-input__button rounded-0"
      @click="increaseValue"
      :disabled="readonly"
    >
      <v-icon :color="color">{{ plusIcon }}</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  name: 'BhNumberInput',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    showSpinners: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    minusIcon: {
      type: String,
      default: 'mdi-minus-circle-outline',
    },
    plusIcon: {
      type: String,
      default: 'mdi-plus-circle-outline',
    },
    minNumber: {
      type: Number,
      default: 0,
    },
    maxNumber: {
      type: Number,
      default: 1000000,
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'accent'
    },
    inputClass: {
      type: String,
      default: ''
    },
  },
  data: () => ({}),
  mounted() {
    if (!this.allowEmpty && Number.isNaN(parseFloat(this.value))) {
      this.updateValue(0)
    }
  },
  methods: {
    decreaseValue() {
      const value = Number.isNaN(parseFloat(this.value))
        ? 0
        : parseFloat(this.value)
      this.updateValue(
        Math.round((parseFloat(value) - parseFloat(this.step)) * 1e12) / 1e12,
      )
    },
    increaseValue() {
      const value = Number.isNaN(parseFloat(this.value))
        ? 0
        : parseFloat(this.value)
      this.updateValue(
        Math.round((parseFloat(value) + parseFloat(this.step)) * 1e12) / 1e12,
      )
    },
    updateValue(value) {
      if (!value && this.allowEmpty) return

      const maxNumber = parseInt(this.maxNumber, 10)
      const minNumber = parseInt(this.minNumber, 10)

      if (value >= maxNumber) {
        this.$refs.input.value = maxNumber
        this.$emit('input', maxNumber)
      } else if (value <= minNumber) {
        this.$refs.input.value = minNumber
        this.$emit('input', minNumber)
      } else if (parseFloat(value) != parseFloat(this.value)) {
        this.$refs.input.value = value
        this.$emit('input', value)
      }
    },
  },
}
</script>
<style lang="scss">
.bh-number-input {
  width: 120px;
  height: 40px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;

  &__button {
    width: 40px !important;
    height: 40px !important;
    background-color: $bh-white;

    &:hover {
      background-color: $bh-gray--6;
    }
  }

  &__input {
    flex: 1;
    text-align: center;
    min-width: 0;
    font-weight: 700;
    line-height: 40px;
    border-top: 1px solid $bh-white;
    border-bottom: 1px solid $bh-white;
    background-color: $bh-white;
    outline: none;
    font-size: 16px;

    &.hide-spinners {
      -moz-appearance: textfield;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }
}
</style>
